import { useRequiredContext } from 'legacy/contexts/utils'
import { NotificationsContext } from 'legacy/contexts/notifications/NotificationsContext'

/**
 * @deprecated prefer `notify` from `@retailer-platform/shared-components` instead
 */
export const useNotifications = () => useRequiredContext(NotificationsContext)
